import React from 'react';
import './Stlye.css';
import banner01 from "./images/banner-01.webp"
import aboutsection from "./images/about-section-01.webp"
import theme23 from "./images/theme23.webp"
import {Tab, Nav} from "react-bootstrap";
import { NavLink } from 'react-router-dom';
import MetaTags from './MetaTags';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faCoins, faUtensils, faChartLine, faLaptopCode } from '@fortawesome/free-solid-svg-icons';

const paragraphStyle = {
    color: 'white', // Set text color to white
  };

const Aboutus = () => {
  return (
    <>
      <MetaTags
        title="About Us | Smart Resources QLD"
        description="Learn more about Smart Resources QLD, our vision, mission, and our active operations in Synthetic Data, Angel Investment, Hospitality, Management Consulting, and Software."
        Canonical="https://smartresourcesqld.com.au/about-us"
        DCTitle="About Us | Smart Resources QLD"
        DCDescription="Learn more about Smart Resources QLD, our vision, mission, and our active operations."
        DCSubject="About Us"
        ogImage={banner01}
        ogTitle="About Us | Smart Resources QLD"
        ogDescription="Learn more about Smart Resources QLD, our vision, mission, and our active operations."
        ogUrl="https://smartresourcesqld.com.au/about-us"
      />

      <section className="innr_banner about_innr_banner">
        <div className="page_title_innr" data-aos="fade-down">
          <div className="page_title">About Us</div>
          <ul className="bread_crumb">
            <li><NavLink to="/" onClick={() => window.scrollTo(0, 0)}>Home</NavLink></li>
            <li>About Us</li>
          </ul>
        </div>
      </section>

      <section className="global_stack_holder">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12" data-aos="fade-right">
              <div className="global_left">
                <div className="global_label_top">
                  About Us
                </div>
                <h1>Empowering Growth Through Innovation</h1>
                <p>At Smart Resources QLD, we are committed to empowering Queensland businesses through innovation, expertise, and tailored solutions. Our team is dedicated to driving success for our clients, whether in synthetic data, angel investment, hospitality, management consulting, or software development.</p>
                <p>With a focus on collaboration and sustainability, we strive to exceed expectations and deliver tangible results that propel businesses forward. Guided by our core values of integrity, excellence, and client satisfaction, we approach each project with enthusiasm and a commitment to excellence. Partner with us to unlock new opportunities and achieve your business objectives with confidence.</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="ct_banner_1">
                <div className="ct_banner_img">
                  <img src={banner01} className="img-fluid" alt="Banner" />
                </div>
                <h3 className="ct-banner-title" data-aos="fade-left">5 Years of Experience</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pricing">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12" data-aos="fade-right">
                        <div className="global_left">
                            <h3>We're ready to share our advice and experience</h3>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12" data-aos="fade-left">
                        <div className="global_right">
                            <p>At Smart Resources QLD, our journey is defined by a commitment to excellence and a passion for driving business success. With a focus on innovation and collaboration, we empower businesses to thrive in a dynamic marketplace. Explore our comprehensive range of services, tailored to meet the diverse needs of Queensland's business community.</p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 px-0" data-aos="fade-up">
                        <NavLink to="/operations/data-science-services-australia" className="realestate" onClick={() => window.scrollTo(0, 0)}>
                            <div className="real_estate_consulting">
                                <div className="consulting_icon" style={{ display: 'flex', alignItems: 'center', height: '60px' }}>
                                    <FontAwesomeIcon icon={faDatabase} style={{ fontSize: '40px', color: '#7a0c2e' }} />
                                </div>
                                <h4>Synthetic Data Services</h4>
                                <p>Build and train machine learning models securely without exposing customer records. By generating statistically representative synthetic twins and applying differential privacy safeguards, we ensure data sovereignty and seamless compliance for businesses.</p>
                            </div>
                        </NavLink>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 px-0" data-aos="fade-up">
                        <NavLink to="/operations/angel-investor" className="realestate" onClick={() => window.scrollTo(0, 0)}>
                            <div className="real_estate_consulting">
                                <div className="consulting_icon" style={{ display: 'flex', alignItems: 'center', height: '60px' }}>
                                    <FontAwesomeIcon icon={faCoins} style={{ fontSize: '40px', color: '#7a0c2e' }} />
                                </div>
                                <h4>Angel Investor</h4>
                                <p>Empower promising ventures and fuel innovation as an angel investor with Smart Resources QLD. With our extensive network, industry expertise, and strategic guidance, we help you identify high-potential investment opportunities and maximize returns, supporting the growth and success of innovative startups.</p>
                            </div>
                        </NavLink>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 px-0" data-aos="fade-up">
                        <NavLink to="/operations/hospitality" className="realestate" onClick={() => window.scrollTo(0, 0)}>
                            <div className="real_estate_consulting">
                                <div className="consulting_icon" style={{ display: 'flex', alignItems: 'center', height: '60px' }}>
                                    <FontAwesomeIcon icon={faUtensils} style={{ fontSize: '40px', color: '#7a0c2e' }} />
                                </div>
                                <h4>Hospitality Operations</h4>
                                <p>Smart Resources QLD is involved in hospitality business operations through Punjabi Palace Brisbane and Punjabi Palace Cairns, with a focus on customer service, operational coordination, service quality, and long-term sustainability.</p>
                            </div>
                        </NavLink>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 px-0" data-aos="fade-up">
                        <NavLink to="/operations/management-consulting" className="realestate" onClick={() => window.scrollTo(0, 0)}>
                            <div className="real_estate_consulting">
                                <div className="consulting_icon" style={{ display: 'flex', alignItems: 'center', height: '60px' }}>
                                    <FontAwesomeIcon icon={faChartLine} style={{ fontSize: '40px', color: '#7a0c2e' }} />
                                </div>
                                <h4>Management Consulting</h4>
                                <p>Smart Resources QLD provides management consulting services focused on business planning, strategic forecasting, process improvement, workflow management, financial operations support, and long-term business growth.</p>
                            </div>
                        </NavLink>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 px-0" data-aos="fade-up">
                        <NavLink to="/operations/software-web-development" className="realestate" onClick={() => window.scrollTo(0, 0)}>
                            <div className="real_estate_consulting">
                                <div className="consulting_icon" style={{ display: 'flex', alignItems: 'center', height: '60px' }}>
                                    <FontAwesomeIcon icon={faLaptopCode} style={{ fontSize: '40px', color: '#7a0c2e' }} />
                                </div>
                                <h4>Software & Web Development</h4>
                                <p>Smart Resources QLD provides professional software and web development services in Queensland. We help businesses design, build, and maintain tailored, scalable software systems and responsive, user-friendly websites designed to meet unique operational needs.</p>
                            </div>
                        </NavLink>
                    </div>
                </div>
            </div>
        </section>

      <section className="what_we_offer"  style={{ 
  backgroundImage: `url(${theme23})` }}>
        <div className="offer_innr">
          <div className="offer_innr_left"></div>
          <div className="offer_innr_right">
            <div className="offr_innr_innr_right">
              <h4>Like What We Offer</h4>
              <h3>Ready to Transform Your Business?</h3>
              <p>Take the first step towards unlocking your business's full potential with Smart Resources QLD. Whether you're seeking strategic guidance, innovative solutions, or investment opportunities, our dedicated team is here to help you succeed. Contact us today to schedule a consultation and discover how we can drive growth, innovation, and success for your business.</p>
              <div className="cont_us">
                <NavLink to="/contact-us" onClick={() => window.scrollTo(0, 0)}>Contact Us <i className="fas fa-angle-right"></i></NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="our_mission" style={{ 
  backgroundImage: `url(${aboutsection})` }}>
            <div className="container">
          <div className="our_mission_tabs">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Nav variant="pills" className="flex-column mission_tabs_left">
            <Nav.Item>
              <Nav.Link eventKey="first">Our Vision</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="second">Our Mission</Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content className='mission_tabs_right'>
            <Tab.Pane eventKey="first">
                  <h4>Our Vision</h4>
                  <p>At Smart Resources QLD, our vision is to be the premier consulting firm, renowned for our expertise, integrity, and commitment to client success. We aim to be the go-to partner for businesses and individuals seeking transformative solutions and strategic insights across diverse industries. By driving innovation, fostering collaboration, and delivering measurable results, we aspire to shape a future where organizations thrive and communities flourish.</p>
            </Tab.Pane>
            <Tab.Pane eventKey="second">
                <h4>Our Mission</h4>
                <p style={paragraphStyle}>
                  Our mission at Smart Resources QLD is to provide unparalleled consulting services across synthetic data, angel investment,
                  hospitality, management consulting, and software development sectors. We strive to empower our clients with innovative
                  solutions, strategic guidance, and exceptional support, fostering growth, sustainability, and prosperity in the
                  communities we serve.
                </p>
            </Tab.Pane>
          </Tab.Content>
    </Tab.Container>
    </div>
            </div>
        </section>
    </>
  );
}

export default Aboutus;
